import {makeStyles} from "@material-ui/core"

export default makeStyles({
    container: {},
    tabs: {
        minHeight: 20,
    },
    tab: {
        fontSize: 12,
        minHeight: 20,
    },
    tabs_content: {
        paddingTop: 10,
    },
    signal_section: {
        overflowX: "scroll",
    },
    signal_container: {
        display: "flex",
        width: 1280,
    },
})
